import React, { useContext } from "react";
import { Badge, Button, Text, LegacyCard as Card, Icon, Link, InlineStack, Thumbnail } from "@shopify/polaris";
import { NoteIcon } from "@shopify/polaris-icons";

import { PrivateContext } from "lib/context";
import constant from "lib/constant/constant";
import { baseHelper, imageHelper } from "lib/helpers";
import { StyledCard } from "app/orders/modules/operator/features/view/genericStyled";
import { useNavigate, useParams } from "react-router-dom";

const PendingForCollect = (props) => {
  const {
    bulkQuantity,
    itemData,
    refundData,
    selectedItems,
    setSelectedItems,
    setSelectedReserveItemData,
    selectedReserveItemData,
    setBulkQuantity,
  } = props;
  const { cms } = useContext(PrivateContext);
  const { id } = useParams();
  const navigate = useNavigate();

  // eslint-disable-next-line no-unused-vars
  const handleChange = (value) => {
    const { fulfillmentStatus, _id: id, collectDetail } = value;
    if (fulfillmentStatus === constant.UNFULFILLED && collectDetail) {
      const found = selectedItems.find((element) => element === id);
      if (found) {
        setSelectedItems(
          selectedItems.filter((item) => {
            return item !== id;
          })
        );
        setSelectedReserveItemData(selectedReserveItemData.filter((item) => item._id !== id));
        setBulkQuantity(bulkQuantity.filter((item) => item.id !== id));
      } else {
        setSelectedItems([...selectedItems, id]);
        setSelectedReserveItemData([...selectedReserveItemData, value]);
        setBulkQuantity([
          ...bulkQuantity,
          {
            id: value._id,
            quantity: value.fulfillableQuantity.toString(),
            totalQuantity: value.actualQuantity.toString(),
          },
        ]);
      }
    }
    // setActive(false);
  };

  const amount = [];
  const vendorsSum = [];

  itemData
    .filter(
      (lineItem) =>
        lineItem.fulfillmentStatus !== constant.FULFILLED &&
        [constant.RESERVE, constant.COLLECT].includes(lineItem.fulfillmentType) &&
        lineItem.collectDetail
    )
    .forEach(({ vendor }) => {
      vendorsSum.push(vendor);
      return vendorsSum;
    });
  const vendorSet = new Set(vendorsSum);
  const setSize = vendorSet.size;
  const addVendorTxt =
    setSize === constant.value.ONE ? `${setSize} ${cms("label.vendor")}` : `${setSize} ${cms("label.vendors")}`;
  const lineDataItems = itemData.filter((lineItem) => {
    const {
      actualQuantity = 0,
      collectDetail,
      fulfillmentStatus = "",
      fulfillmentType = "",
      isRefund,
      quantity = 0,
    } = lineItem;
    return (
      [constant.UNFULFILLED, constant.PARTIAL].includes(fulfillmentStatus) &&
      [constant.RESERVE, constant.COLLECT].includes(fulfillmentType) &&
      !!collectDetail &&
      (isRefund
        ? collectDetail && collectDetail.readyQuantity < (quantity || 0)
        : collectDetail && collectDetail.readyQuantity < (actualQuantity || 0))
    );
  }).length;

  const lineItems =
    itemData &&
    itemData.length &&
    itemData
      .filter((lineItem) => {
        const {
          actualQuantity = 0,
          collectDetail,
          fulfillmentStatus = "",
          fulfillmentType = "",
          isRefund,
          quantity = 0,
        } = lineItem;
        return (
          [constant.UNFULFILLED, constant.PARTIAL].includes(fulfillmentStatus) &&
          [constant.RESERVE, constant.COLLECT].includes(fulfillmentType) &&
          !!collectDetail &&
          (isRefund
            ? collectDetail && collectDetail.readyQuantity < (quantity || 0)
            : collectDetail && collectDetail.readyQuantity < (actualQuantity || 0))
        );
      })
      .map((lineData, idx) => {
        const {
          collectDetail = {},
          image = "",
          isProductDeleted,
          isRefund = false,
          moneyFormat: lineMoneyFormat,
          name,
          productId,
          price,
          quantity = 0,
          sku,
          status,
          vendor,
          fulfillmentType: lineItemFulfillmentType,
          shopifyLineItemId,
        } = lineData || {};

        let { actualQuantity = 0 } = lineData || {};
        const { readyQuantity = 0 } = collectDetail || {};
        if (isRefund && refundData) {
          refundData.forEach((refundItem) => {
            const { totalQuantity = 0, line_item_id: shopifyId = "" } = refundItem;
            if (shopifyLineItemId === shopifyId) {
              actualQuantity += totalQuantity;
            }
          });
        }
        const lineItemKey = `lineItem${idx}`;
        const lineImage =
          imageHelper.resize({ url: image, type: constant.imageTypes.THUMBNAIL }) || constant.NOIMAGESNAP;

        const moneyFormat = lineMoneyFormat || constant.symbol.DOLLAR;

        const totalQuantity = parseInt(actualQuantity || quantity, 10) - parseInt(readyQuantity, 10);
        const totalPrice = totalQuantity * price;
        amount.push(totalPrice);

        const lineItemName = <div className="productName">{name}</div>;

        return (
          <div key={lineItemKey} className="fulfilled-Secn">
            <Card>
              <Card.Section subdued>
                <StyledCard className="styled-card-unfulfill">
                  <InlineStack wrap={false}>
                    <Thumbnail size="large" source={lineImage} alt={name} />
                    <div className="ellipsis">
                      {(isProductDeleted && (lineItemName || "")) || (
                        <Link onClick={() => navigate(`/products/edit/${productId}`)}>{name || ""}</Link>
                      )}

                      <Text variant="bodySm" as="p">
                        <Text as="span" color={constant.SUBDUED}>
                          {vendor ? `${cms("label.vendor")}: ${vendor}` : ""}
                        </Text>
                        <Text as="span" color={constant.SUBDUED}>
                          {cms("label.skuList")}
                          {sku}
                        </Text>
                      </Text>

                      <Badge status={baseHelper.getBadgeType(status)} className="text-capitalize">
                        Partially ready for collection
                      </Badge>

                      <Button variant="plain" size="slim" onClick={() => window.open(`/order-slip/${id}`)}>
                        <InlineStack gap="2" blockAlign="center">
                          <Icon source={NoteIcon} />
                          {lineItemFulfillmentType === constant.RESERVE && (
                            <Text as="span">{`${cms("label.reserveSlip")}`}</Text>
                          )}
                          {lineItemFulfillmentType === constant.COLLECT && (
                            <Text as="span">{`${cms("label.pickupSlip")}`}</Text>
                          )}
                        </InlineStack>
                      </Button>
                    </div>
                    <Text as="span">{` ${cms("label.qty")}: ${totalQuantity}`}</Text>
                    <Text as="h5">
                      {moneyFormat}
                      {(totalPrice && totalPrice.toFixed(2)) || constant.value.ZERO}
                    </Text>
                  </InlineStack>
                </StyledCard>
              </Card.Section>
            </Card>
          </div>
        );
      });

  const stringToNumber = amount.map((item) => parseFloat(item));
  const totalAmount = stringToNumber.reduce((cur, acc) => cur + acc, constant.value.ZERO);

  const moneyFormat = (itemData && itemData.length && itemData[0].moneyFormat) || constant.symbol.DOLLAR;
  const totalFulfill = (
    <Card.Section>
      <InlineStack>
        <Text as="span" fontWeight="semibold">
          {cms("label.total")}
        </Text>
        <Text variant="bodySm" as="p">
          (
          {lineDataItems > 1
            ? `${lineDataItems}
                ${cms("label.items")} from ${addVendorTxt}`
            : `${lineDataItems}
                ${cms("label.item")} from ${addVendorTxt}`}
          )
        </Text>
        <Text as="span" fontWeight="semibold">{`${moneyFormat}${totalAmount.toFixed(2)}`}</Text>
      </InlineStack>
    </Card.Section>
  );

  return [lineItems, totalFulfill];
};

export default PendingForCollect;
